import styled from 'styled-components'
import { updatedMedia } from 'client/styles'

export const PaymentOgoneBase = styled.div``

export const Iframe = styled.iframe`
  width: 100%;
  height: ${props => (props.customSubmit ? '348px' : '450px')};

  ${updatedMedia.onlyMobile} {
    height: ${props => (props.customSubmit ? '348px' : '500px')};
  }
`
